// @flow
import { createSelector } from 'reselect';
import { map } from 'lodash';

function getSearchResults(allFriends, allRequests, searchUsers) {
  // Look in our search results for known friends/requests and replace the search result
  // with the friend/request so we have all the information on them
  return map(searchUsers, user => allFriends[user.id] || allRequests[user.id] || user);
}

const searchFriendsSelector = createSelector(
  (state: GlobalState) => state.friends.friends,
  (state: GlobalState) => state.friendRequests.friendRequests,
  (state, searchId) => state.friendSearch.users[searchId],
  getSearchResults
);

export default searchFriendsSelector;
